<!-- new theme implementation starts -->
<div class="subheader with-padding flgrow">
    <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-8">
            <div class="flmid">
                <div class="flgrow">
                    <div class="input-group">
                        <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearch' | translate }}"
                        [(ngModel)]="pService.searchTerm" autocomplete="off" />
                        <div class="input-group-append">
                            <button type="button" class="btn btn-primary">
                                <em class="fa fa-search"></em>
                            </button>
                          </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container prel">


    <div class="row">
        <div class="c12">
            <div class="card mb-3">
                <div class="card-header d-flex">
                    <h4 class="card-title" translate>lblSyncJobs</h4>

                </div>

                <div class="table-responsive">
                    <table class="tablest1">
                        <thead>
                            <tr>
                                <th style="width: 55px" scope="col">#</th>
                                <th scope="col" sortable="" (sort)="onSort($event)" translate>lblJobName</th>
                                <th scope="col" sortable="" (sort)="onSort($event)" translate>lblDescription</th>
                                <th scope="col" sortable="" (sort)="onSort($event)" translate>lblLastSyncTime</th>
                                <th scope="col" sortable="" (sort)="onSort($event)" translate>lblLastSyncStatus</th>
                                <th scope="col" sortable="" (sort)="onSort($event)" translate>lblLastSuccess</th>
                                <th scope="col" sortable="" (sort)="onSort($event)" translate>lblInProgress</th>
                                <th scope="col" sortable="" (sort)="onSort($event)" translate>lblRunJob</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="syncJobList && syncJobList.length > 0; else load_else">
                                <tr *ngFor="let syncJob of syncJobList; let i=index">
                                    <td>{{syncJob.rowNumber}}</td>
                                    <td>
                                        <ngb-highlight [result]="syncJob.jobName" [term]="pService.searchTerm">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="syncJob.description" [term]="pService.searchTerm">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="syncJob.lastSyncTime | date:'short' " [term]="pService.searchTerm">
                                        </ngb-highlight>
                                    </td>
                                    <td>

                                        <span *ngIf="syncJob.isLastSyncSuccess; else load_elsefail" translate>
                                            lblSuccess
                                        </span>
                                        <ng-template #load_elsefail translate>
                                            lblFail
                                        </ng-template>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="syncJob.lastSuccess | date:'short'" [term]="pService.searchTerm">
                                        </ngb-highlight>
                                    </td>
                                    <td translate>
                                        <span *ngIf="syncJob.isInProgress; else load_else" translate>
                                            lblYes
                                        </span>
                                        <ng-template #load_else translate>
                                            lblNot
                                        </ng-template>
                                    </td>
                                    <td>
                                        <a (click)="OnTriggerJob(syncJob)" class="btn btn-primary btn-sm" translate>lblTriggerJob</a>
                                    </td>
                                </tr>
                            </ng-container>
                            <ng-template #load_else>
                                <tr>
                                    <td colspan="4" class="no-record" translate>lblNoRecordsFound</td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>

                <div class="card-footer">
                    <div class="d-flex justify-content-between">
                        <div class="d-flex justify-content-between">
                            <ngb-pagination [collectionSize]="pService.total$  | async" [(page)]="pService.page"
                                [pageSize]="pService.pageSize" [maxSize]="3">
                            </ngb-pagination>
                            <select class="custom-select mx-2" style="width: auto" name="pageSize"
                                [(ngModel)]="pService.pageSize">
                                <option *ngFor="let item of pService.pageItemsArray" [ngValue]="item.values" translate>
                                    {{item.label}}
                                </option>
                            </select>
                        </div>
                        <div class="d-flex justify-content-between p-2 font17 fontbold" style="margin: auto 0;">
                            <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{pService.total$ |
                            async}}&nbsp;<span class="font17 fontnormal" translate>lblResults</span>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
